import styles from "./PageContent.module.css"

type PageContentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  header?: React.ReactNode;
  children?: React.ReactNode;
  shrink?: boolean;
};

export default function PageContent(props: PageContentProps) {
  const { header, children, className, shrink, ...rest } = props;
  return (
    <div className={styles.pageContent}>
      {header &&
        <div className={styles.headerContainer}>
          <div className={styles.headerContent}>{header}</div>
        </div>
      }
      <div className={styles.bodyContainer}>
        <div
          className={`${styles.bodyContent} ${className ?? ""}`}
          style={{height: shrink ? "" : "max-content"}}
          {...rest}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
